import { t, wanneer } from '../i18n.js';
import { St } from './Status.jsx';
import { MODULE_ICOON } from './iconen.jsx';

/**
 * De modules van één klant als kaarten (docs/besluiten/modules-per-klant.md): de stand, wat er nog moet gebeuren om hem
 * aan te zetten, en wat jij hier kunt doen. Dezelfde kaarten voor Beheer, voor de klant zelf en bij meekijken; `doe`
 * bepaalt welke knoppen er staan (geen `doe`: alleen lezen).
 *
 * doe: { afnemen?(id, aan), schakel?(id, aan), interesse?(id) }. `ookOningericht`: aanzetten mag al voordat hij is ingericht
 * (een medewerker; de klant zelf niet).
 */
const STAND = {
  aan: ['good', 'Aan'], klaar: ['warning', 'Klaar om aan te zetten'], 'af te maken': ['warning', 'Af te maken'],
  'niet afgenomen': ['neutral', 'Niet afgenomen'],
};

export default function ModuleKaarten({ modules, doe = {}, bezig = false, ookOningericht = false }) {
  return (
    <div className="modgrid">
      {modules.map((m) => {
        const [soort, label] = STAND[m.state];
        const kan = (x) => typeof doe[x] === 'function' && !m.fixed;
        return (
          <section key={m.id} className={`card modcard ${m.state.replace(/ /g, '-')}`}>
            <header><h3><span className="modicoon">{MODULE_ICOON[m.id]}</span>{t(m.label)}</h3><St soort={soort}>{t(label)}</St></header>
            <p className="soft" style={{ fontSize: 13, margin: '0 0 8px' }}>{t(m.help)}</p>
            {m.state !== 'niet afgenomen' && m.steps.length > 0 && (
              <ul className="checks modchecks">
                {m.steps.map((s) => <li key={s.id}><St soort={s.ok ? 'good' : 'warning'} /><span>{t(s.label)}</span></li>)}
              </ul>
            )}
            {m.fixed && <p className="muted" style={{ fontSize: 12.5, margin: 0 }}>{m.id === 'basis' ? t('Basis staat altijd aan.') : t('De eigen klant heeft alle modules.')}</p>}
            {!m.fixed && m.changedAt && <p className="muted" style={{ fontSize: 12, margin: '4px 0 0' }}>{t('Gewijzigd {wanneer}', { wanneer: wanneer(m.changedAt) })}{m.changedBy ? ` · ${m.changedBy}` : ''}</p>}
            <div className="actions" style={{ justifyContent: 'flex-start' }}>
              {kan('schakel') && m.state === 'aan' && <button type="button" className="btn" disabled={bezig} onClick={() => doe.schakel(m.id, false)}>{t('Uitzetten')}</button>}
              {kan('schakel') && m.state === 'klaar' && <button type="button" className="btn primary" disabled={bezig} onClick={() => doe.schakel(m.id, true)}>{t('Aanzetten')}</button>}
              {kan('schakel') && ookOningericht && m.state === 'af te maken' && <button type="button" className="btn" disabled={bezig} onClick={() => doe.schakel(m.id, true)}>{t('Toch aanzetten')}</button>}
              {m.state === 'af te maken' && !m.fixed && <span className="muted" style={{ fontSize: 13 }}>{ookOningericht && kan('schakel')
                ? t('Er komen pas alerts als de stappen hierboven gedaan zijn.') : t('Eerst de stappen hierboven; dan kan hij aan.')}</span>}
              {kan('afnemen') && m.state === 'niet afgenomen' && <button type="button" className="btn" disabled={bezig} onClick={() => doe.afnemen(m.id, true)}>{t('Afnemen (met de hand)')}</button>}
              {kan('afnemen') && m.state !== 'niet afgenomen' && <button type="button" className="namelink gevaar" disabled={bezig} onClick={() => doe.afnemen(m.id, false)}>{t('Niet meer afnemen')}</button>}
              {kan('interesse') && m.state === 'niet afgenomen' && <button type="button" className="btn" disabled={bezig} onClick={() => doe.interesse(m.id)}>{t('Interesse doorgeven')}</button>}
            </div>
          </section>
        );
      })}
    </div>
  );
}
